import { useQuery } from '@tanstack/react-query';
import { useTramaClient } from '../context.js';

export function useCmsItems(collectionId: string | null) {
  const client = useTramaClient();

  return useQuery({
    queryKey: ['cms', collectionId],
    queryFn: () => client.request<unknown[]>(`/api/v1/cms/collections/${collectionId}/items`),
    enabled: Boolean(collectionId),
    staleTime: 5 * 60 * 1000,
  });
}
